<div class="pill-selector l_flex l_flex-top">
  <button
    class="pill-selector-option guts-p-h-1 ib"
    *ngFor="let option of options; trackBy: getOptionId"
    [class.pill-selector-option__selected]="option.id === selectedId"
    [attr.aria-label]="option.ariaLabel"
    attr.data-dgat="pill-selector-{{ option.id }}"
    (click)="clickHandler(option)"
    role="radio"
    [attr.aria-checked]="option.id === selectedId"
  >
    <df-icon
      *ngIf="option.icon"
      [ngbTooltip]="option.label"
      container="body"
      [icon]="option.icon"
      class="pill-selector-option-icon"
    ></df-icon>
  </button>
</div>
